@import 'style-sheet-helpers/core.less';

.configure-inventory-warehouse-body {
  padding: 16px 16px 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-size: 14px;
}

.loading-indicator {
  height: 60px;
  width: 60px;
  place-self: center flex-end;
}

.descriptor {
  line-height: 1.5;
}

.configure-inventory-warehouse-input-label {
  font-weight: @semi-bold;
  margin-bottom: 8px;
}

.configure-inventory-warehouse-input {
  margin: 0;
  padding-left: 0;
  text-align: left;
  width: 40%;
}

.linked-shipfroms {
  display: flex;
  gap: 8px;
  flex-direction: column;
  margin-top: 8px;
}

.linked-shipfroms-list {
  justify-self: start;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.linked-shipfroms-label {
  font-weight: @semi-bold;
}

.configure-inventory-warehouse-footer {
  display: flex;
  justify-content: flex-end;
}
